/**
 * home
 */

export default [
  {
    name: 'home',
    path: '/home',
    meta: {
      title: '首页',
      href: '/home',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'home' */ '@/views/home')
  },
  {
    name: 'projectAll',
    path: '/projectAll',
    menuName: '所有项目',
    meta: {
      title: '所有项目',
      href: '/projectAll',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'projectAll' */ '@/views/project/projectall')
  },
  {
    name: 'main',
    path: '/main',
    menuName: '工作台',
    menuUrl: '/main',
    image: 'image/home/home-1',
    isParent: true,
    noLevel: true,
    redirect: '/main/myTask',
    meta: {
      title: '工作台',
      href: '/main',
      redirect: 'noredirect',
      projectStatus: true
    },
    component: () => import(/* webpackChunkName: 'team' */ '@/views/main'),
    children: [
      {
        name: 'myProject',
        path: 'myProject',
        redirect: '/main/myProject/starProject',
        meta: {
          title: '工作台',
          href: '/myProject',
          redirect: 'noredirect',
          projectStatus: true,
          active: '/main'
          // header: true
        },
        component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myProject'),
        children: [
          {
            name: 'projectFolder',
            path: 'projectFolder',
            meta: {
              title: '工作台',
              href: '/projectFolder',
              redirect: 'noredirect',
              projectStatus: true,
              active: '/main'
              // header: true
            },
            component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myProject/project')
          },
          {
            name: 'crossProject',
            path: 'crossProject',
            meta: {
              title: '工作台',
              href: '/crossProject',
              redirect: 'noredirect',
              projectStatus: true,
              active: '/main',
              treeActive: '/crossProject'
              // header: true
            },
            component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myProject/crossProject')
          },
          {
            name: 'crossProjectDetail',
            path: 'crossProjectDetail',
            meta: {
              title: '工作台',
              href: '/crossProjectDetail',
              redirect: 'noredirect',
              projectStatus: true,
              active: '/main',
              treeActive: '/crossProject'
              // header: true
            },
            component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myProject/crossProject/crossProjectDetail/crossProjectDetail')
          },
          {
            name: 'starProject',
            path: 'starProject',
            meta: {
              title: '工作台',
              href: '/starProject',
              redirect: 'noredirect',
              projectStatus: true,
              active: '/main',
              treeActive: '/starProject'
              // header: true
            },
            component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myProject/starProject')
          }
        ]
      },
      {
        name: 'myTask',
        path: 'myTask',
        meta: {
          title: '工作台',
          href: '/myTask',
          redirect: 'noredirect',
          projectStatus: true,
          active: '/main'
          // header: true
        },
        component: () => import(/* webpackChunkName: 'project' */ '@/views/main/myTask')
      }
    ]
  },
  //   {
  //   name: 'project',
  //   path: '/project',
  //   menuName: '工作台',
  //   menuUrl: '/project',
  //   image: 'image/home/home-1',
  //   isParent: true,
  //   meta: {
  //     title: '工作台',
  //     href: '/project',
  //     redirect: 'noredirect',
  //     projectStatus: true,
  //     // header: true
  //   },
  //   component: () => import( /* webpackChunkName: 'project' */ '@/views/project/index'),
  // },
  // {
  //   name: 'projectFolder',
  //   path: '/projectFolder',
  //   meta: {
  //     title: '项目业务',
  //     href: '/projectFolder',
  //     redirect: 'noredirect',
  //     projectStatus: true,
  //     isTab: true,
  //     active: '/project'
  //     // header: true
  //   },
  //   component: () => import( /* webpackChunkName: 'project' */ '@/views/project/projectFolder'),
  // },
  {
    name: 'templateProject',
    path: 'templateProject',
    meta: {
      title: '项目模板',
      href: '/templateProject',
      redirect: 'noredirect',
      projectStatus: true,
      active: '/main',
      treeActive: '/templateProject'
      // header: true
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/main/templateProject')
  },
  {
    name: 'templateProject',
    path: 'templateProject',
    meta: {
      title: '项目模板',
      href: '/templateProject',
      redirect: 'noredirect',
      projectStatus: true,
      active: '/main',
      treeActive: '/templateProject'
      // header: true
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/main/templateProject')
  },
  {
    name: 'templateProjectDetail',
    path: 'templateProjectDetail',
    meta: {
      title: '项目模板详情',
      href: '/templateProjectDetail',
      redirect: 'noredirect',
      projectStatus: true,
      active: '/main',
      treeActive: '/templateProjectDetail'
      // header: true
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/main/templateProject/detail')
  },
  {
    name: 'projectMemberSetting',
    path: '/projectMemberSetting',
    menuName: '项目成员设置',
    meta: {
      title: '项目成员设置',
      href: '/projectMemberSetting',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/project/memberSetting')
  },
  {
    name: 'projectMember',
    path: '/projectMember',
    meta: {
      title: '项目成员',
      href: '/projectMember',
      redirect: 'noredirect',
      isTab: true,
      addMember: true
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/project/member')
  },
  {
    name: 'realMessageTask',
    path: '/realMessageTask',
    meta: {
      title: '通知',
      href: '/realMessageTask',
      redirect: 'noredirect',
      isTab: true,
      addMember: true
    },
    component: () => import(/* webpackChunkName: 'realMessage2' */ '@/views/realMessage')
  },
  {
    name: 'recycleBin',
    path: '/recycleBin',
    meta: {
      title: '回收站',
      href: '/recycleBin',
      redirect: 'noredirect',
      isTab: true
      // header: true
    },
    component: () => import(/* webpackChunkName: 'project' */ '@/views/task/recycleBin')
  },
  {
    name: 'archivingTask',
    path: '/archivingTask',
    meta: {
      title: '归档任务',
      href: '/archivingTask',
      redirect: 'noredirect',
      isTab: true
    },
    component: () => import(/* webpackChunkName: 'archivingTask' */ '@/views/task/taskArchiving')
  },
  {
    name: 'dynamic',
    path: '/dynamic',
    menuName: '动态',
    menuUrl: '/dynamic',
    image: 'image/home/home-2',
    isParent: true,
    meta: {
      keepAlive: true,
      title: '动态',
      href: '/dynamic',
      redirect: 'noredirect',
      rank: 1
    },
    component: () => import(/* webpackChunkName: 'dynamic' */ '@/views/dynamic')
  },
  {
    name: 'team',
    path: '/team',
    menuName: '团队',
    menuUrl: '/team',
    image: 'image/home/home-3',
    isParent: true,
    meta: {
      title: '团队',
      href: '/team',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'team' */ '@/views/team/main-core')
  },
  {
    name: 'mySetting',
    path: '/mySetting',
    meta: {
      title: '个人设置',
      href: '/mySetting',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'mySetting' */ '@/views/mySetting')
  },
  {
    name: 'systemSetting',
    path: '/systemSetting',
    component: () => import(/* webpackChunkName: 'systemSetting' */ '@/views/systemSetting'),
    meta: {
      title: '系统设置',
      href: '/systemSetting',
      redirect: 'noredirect'
    }
  },
  {
    name: 'business',
    path: '/business',
    component: () => import(/* webpackChunkName: 'business' */ '@/views/systemSetting/business'),
    meta: {
      title: '管理业务板块',
      href: '/business',
      redirect: 'noredirect'
    }
  },
  {
    name: 'realMessage',
    path: '/realMessage',
    component: () => import(/* webpackChunkName: 'realMessage' */ '@/views/realMessage'),
    meta: {
      title: '通知中心',
      href: '/realMessage',
      redirect: 'noredirect'
    }
  },
  {
    name: 'taskExel',
    path: '/taskExel',
    component: () => import(/* webpackChunkName: 'taskExel' */ '@/views/statistics/taskExel'),
    meta: {
      keepAlive: true,
      rank: 4,
      title: '任务执行情况',
      href: '/taskExel',
      isTab: true,
      redirect: 'noredirect'
    }
  },
  {
    name: 'projectSetting',
    path: '/projectSetting',
    component: () => import(/* webpackChunkName: 'projectSetting' */ '@/views/projectSetting'),
    meta: {
      keepAlive: true,
      rank: 4,
      title: '项目管理',
      href: '/projectSetting',
      isTab: true,
      redirect: 'noredirect'
    }
  },
  {
    name: 'crossProjectSetting',
    path: '/crossProjectSetting',
    component: () => import(/* webpackChunkName: 'crossProjectSetting' */ '@/views/projectSetting/crossProject'),
    meta: {
      keepAlive: true,
      rank: 4,
      title: '项目管理',
      href: '/crossProjectSetting',
      isTab: true,
      redirect: 'noredirect'
    }
  },
  {
    name: 'cloudHosting',
    path: '/cloudHosting',
    menuName: '云空间',
    menuUrl: '/cloudHosting',
    image: 'image/home/home-5',
    isParent: true,
    meta: {
      title: '云空间',
      href: '/cloudHosting',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'cloudHosting' */ '@/views/cloudHosting')
  },
  {
    name: 'productData',
    path: '/productData',
    menuName: '产品数据管理',
    menuUrl: '/productData',
    image: 'image/home/home-7',
    permissions: '产品数据管理',
    isParent: true,
    meta: {
      title: '产品数据管理',
      href: '/productData',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'productData' */ '@/views/productData')
  },
  {
    name: 'productDataAdd',
    path: '/productDataAdd',
    meta: {
      title: '新建产品项',
      href: '/productDataAdd',
      redirect: 'noredirect',
      active: '/productData'
    },
    component: () => import(/* webpackChunkName: 'productDataAdd' */ '@/views/productData/detail/add')
  },
  {
    name: 'productDataIndex',
    path: '/productDataIndex',
    meta: {
      title: '产品详情',
      href: '/productDataIndex',
      redirect: 'noredirect',
      active: '/productData'
    },
    component: () => import(/* webpackChunkName: 'productDataIndex' */ '@/views/productData/detail')
  }
]
